import dayjs from 'dayjs'
import { MapReceiptType, ReceiptUploadType } from '../../constants/paymentDetail'
import { getUploadType } from '../../helpers/receipt'
import { DocumentDetailModel } from '../../models/documentDetail'
import { PaymentObjectiveModel } from '../../models/paymentObjective'
import { appStore } from '../../redux/store'
import { isBranchStaff } from '../../helpers/roles'

// '1','เงินสด','เงินสด','CASH'
// '2','เช็คธนาคาร','เช็คธนาคาร','CKC'
// '3','บัตรเครดิต','บัตรเครดิต','CC'
// '4','อื่นๆ','อื่นๆ','OTHER'
// '5','โอนเงินสดเข้าบัญชีธนาคาร','โอนเงินสดเข้าบัญชีธนาคาร','CASHPAYIN'
// '6','นำเช็คเข้าบัญชีธนาคาร','นำเช็คเข้าบัญชีธนาคาร','CKCPAYIN'
// '7','เช็คสั่งจ่ายโดย FWD','เช็คสั่งจ่ายโดย FWD','FWDCKC'
// '8','QR Code','QR Code','QRCODE'

export const validateDateFwdCkc = (date: string) => {
  return dayjs().diff(dayjs(date), 'days') > 180
}

export const validateMonthCreditCard = (value: string) => {
  const splitValue = value.split('/')
  if (splitValue[0].trim().length === 2) {
    const monthNumber = Number(splitValue[0].trim())

    if (monthNumber <= 0 || monthNumber > 12) {
      return false
    }
  }

  return true
}

export const validateCheckboxDetailField = (error: any, paymentDetail: DocumentDetailModel[]) => {
  paymentDetail.forEach(item => {
    if (item.isCheck) {
      if (item.paymentMethod.id === 1) {
        !item.paymentAmount && (error.paymentAmountCash = true)
      }

      if (item.paymentMethod.id === 2) {
        !item.cheque_Bank && (error.cheque_Bank = true)
        !item.cheque_Branch && (error.cheque_Branch = true)
        !item.cheque_Number && (error.cheque_Number = true)
        !item.cheque_Date && (error.cheque_Date = true)
        !item.paymentAmount && (error.paymentAmountBank = true)
        !item.paymentTotalAmount && (error.paymentTotalAmount = true)
      }

      if (item.paymentMethod.id === 3) {
        const splitExpireFormat = item.creditCard_ExpDate.split('/')
        const expireCard = dayjs(`20${splitExpireFormat[1]}-${splitExpireFormat[0]}-01`).format(
          'YYYY-MM-DD'
        )
        let isNotExpireCard = dayjs().isSameOrBefore(expireCard, 'month')

        if (isNotExpireCard) {
          isNotExpireCard = validateMonthCreditCard(item.creditCard_ExpDate)
        }

        !item.creditCard_HolderName && (error.creditCard_HolderName = true)
        !item.creditCard_Type && (error.creditCard_Type = true)
        !item.creditCard_Number && (error.creditCard_Number = true)
        !(item.creditCard_Number.replace(/ /g, '').length == 16) && (error.creditCard_Number = true)
        !isNotExpireCard && (error.creditCard_ExpDate = 'กรุณาตรวจสอบวันหมดอายุบัตร')
        !item.creditCard_ExpDate && (error.creditCard_ExpDate = 'กรุณากรอกข้อมูล')
        !item.paymentAmount && (error.paymentAmountCard = true)
      }

      if (item.paymentMethod.id === 0) {
        !item.other_Pay && (error.other_Pay = true)
        !item.paymentAmount && (error.paymentAmountOther = true)
      }

      if (item.paymentMethod.id === 5) {
        //อนเงินสดเข้าบัญชีธนาคาร
        !item.bankCode && (error.BankCodeCashPayIn = true)
        !item.accountNo && (error.AccountNoCashPayIn = true)
        !item.payInDate && (error.PayInDateCashPayIn = true)
        !item.paymentAmount && (error.paymentAmountCashPayIn = true)
      }
      if (item.paymentMethod.id === 6) {
        !item.cheque_Bank && (error.cheque_Bank_CKCPayIn = true)
        !item.cheque_Branch && (error.cheque_Branch_CKCPayIn = true)
        !item.cheque_Number && (error.cheque_Number_CKCPayIn = true)
        !item.cheque_Date && (error.cheque_Date_CKCPayIn = true)
        !item.bankCode && (error.BankCodeCKCPayIn = true)
        !item.accountNo && (error.AccountNoCKCPayIn = true)
        !item.payInDate && (error.PayInDateCKCPayIn = true)
        !item.paymentAmount && (error.paymentAmountCKCPayIn = true)
        !item.paymentTotalAmount && (error.paymentTotalAmount = true)
      }
      if (item.paymentMethod.id === 7) {
        !item.cheque_Number && (error.cheque_Number_FWDCKC = true)
        !item.paymentAmount && (error.paymentAmount_FWDCKC = true)

        if (!item.cheque_Date) {
          error.cheque_Date_FWDCKC = true
        } else if (validateDateFwdCkc(item.cheque_Date)) {
          error.cheque_Date_FWDCKC = 'ต้องไม่เกิน 180 วัน'
        }
      }
      if (item.paymentMethod.id === 8) {
        !item.bankCode && (error.BankCode_QRCode = true)
        !item.accountNo && (error.AccountNo_QRCode = true)
        !item.payInDate && (error.PayInDate_QRCode = true)
        !item.paymentAmount && (error.paymentAmount_QRCode = true)
      }
    }
  })

  return Object.keys(error).length === 0 ? true : false
}

export const validateCheckboxObjectField = (
  error: any,
  paymentObjectives: PaymentObjectiveModel[]
) => {
  paymentObjectives.forEach(item => {
    if (item.isCheck) {
      if (item.paymentObjectiveType.id === 1) {
        !item.amount && (error.premium_NB = true)
      }

      if (item.paymentObjectiveType.id === 2) {
        !item.amount && (error.premium_add_NB = true)
      }

      if (item.paymentObjectiveType.id === 3) {
        !item.amount && (error.premium_change = true)
      }

      if (item.paymentObjectiveType.id === 4) {
        !item.amount && (error.premium_renew = true)
      }

      if (item.paymentObjectiveType.id === 5) {
        !item.amount && (error.premium_loan = true)
      }

      if (item.paymentObjectiveType.id === 6) {
        !item.amount && (error.premium_extra = true)
      }

      if (item.paymentObjectiveType.id === 7) {
        !item.amount && (error.premium_group = true)
      }

      if (item.paymentObjectiveType.id === 8) {
        !item.amount && (error.premium_oth_fee = true)
      }
    }
  })

  return Object.keys(error).length === 0 ? true : false
}

export const validateUploadFile = (
  paymentMethodId: number,
  receipt: ReceiptModel[],
  errors: any[]
) => {
  const isBranch = isBranchStaff((appStore.getState().loginReducer as any).account?.agentInfo.role)
  if (!isBranch) {
    const uploadFileType = getUploadType(paymentMethodId, [], isBranch).filter(item => item.require)
    for (const file of uploadFileType) {
      const uploaded = receipt?.find(item => item.fileType === file.name)
      if (!uploaded) {
        errors.push({
          key: file.name,
          error: 'โปรดตรวสอบเอกสาร ' + MapReceiptType[file.name as keyof typeof ReceiptUploadType]
        })
      }
    }
  }
}

export const validateUploadFile_CC = (
  paymentMethodId: number,
  receipt: ReceiptModel[],
  errors: any[],
  creditCard_Type_dcr: any
) => {
  const isBranch = isBranchStaff((appStore.getState().loginReducer as any).account?.agentInfo.role)
  if (!isBranch) {
    const uploadFileType = getUploadType(paymentMethodId, [], isBranch).filter(item => item.require)
    for (const file of uploadFileType) {
      const uploaded = receipt?.find(item => item.fileType === file.name)
      if (!uploaded) {
        if (!['VSA', 'JCB', 'MAS'].includes(creditCard_Type_dcr)) {
          errors.push({
            key: file.name,
            error: 'โปรดตรวสอบเอกสาร ' + MapReceiptType[file.name as keyof typeof ReceiptUploadType]
          })
        }
      }
    }
  }
}

export const validateCash = (data: DocumentDetailModel) => {
  const errors: { key: string; error: string }[] = []
  const checkData = [
    { key: 'paymentAmount', error: 'กรุณาตรวจสอบจำนวนเงิน' },
    { key: 'bankCode', error: 'กรุณาตรวจสอบธนาคาร' },
    { key: 'accountNo', error: 'กรุณาตรวจสอบเลขที่บัญชี' },
    { key: 'payInDate', error: 'กรุณาตรวจสอบวันที่ฝาก' }
  ]

  for (const check of checkData) {
    if (!data[check.key as keyof DocumentDetailModel]) {
      errors.push(check)
    }
  }

  validateUploadFile(data.paymentMethod.id, data.receipt || [], errors)

  return errors
}

/**
 * use validateCKC for CKC and CKCPayin
 */
export const validateCKC = (data: DocumentDetailModel) => {
  const errors: { key: string; error: string }[] = []
  const checkData = [
    { key: 'paymentAmount', error: 'กรุณาตรวจสอบจำนวนเงิน' },
    { key: 'paymentTotalAmount', error: 'กรุณาตรวจสอบจำนวนเงินตามหน้าเช็ค' },
    { key: 'cheque_Number', error: 'กรุณาตรวจสอบเลขที่เช็ค' },
    { key: 'cheque_Date', error: 'กรุณาตรวจสอบเช็คลงวันที่' },
    { key: 'cheque_Bank', error: 'กรุณาตรวจสอบธนาคารเจ้าของเช็ค' },
    { key: 'cheque_Branch', error: 'กรุณาตรวจสอบสาขาธนาคารเจ้าของเช็ค' },
    { key: 'bankCode', error: 'กรุณาตรวจสอบธนาคาร' },
    { key: 'accountNo', error: 'กรุณาตรวจสอบเลขที่บัญชี' },
    { key: 'payInDate', error: 'กรุณาตรวจสอบวันที่ฝาก' }
  ]

  for (const check of checkData) {
    if (!data[check.key as keyof DocumentDetailModel]) {
      errors.push(check)
    }
  }

  validateUploadFile(data.paymentMethod.id, data.receipt || [], errors)

  return errors
}

export const validateCC = (data: DocumentDetailModel) => {
  const errors: { key: string; error: string }[] = []
  const checkKey = [
    { key: 'paymentAmount', error: 'กรุณาตรวจสอบจำนวนเงิน' },
    { key: 'creditCard_Number', error: 'กรุณาตรวจสอบเลขที่' },
    { key: 'creditCard_Type', error: 'กรุณาตรวจสอบประเภท' },
    { key: 'creditCard_ExpDate', error: 'กรุณาตรวจสอบวันหมดอายุ' },
    { key: 'creditCard_HolderName', error: 'กรุณาตรวจสอบชื่อเจ้าของบัตร' },
    {
      key: 'creditCard_HolderRelationship',
      error: 'กรุณาตรวจสอบเจ้าของบัตรเครดิตมีความสัมพันธ์เป็นอะไรกับผู้เอาประกันภัย'
    }
    //{ key: 'creditCard_SignDate', error: 'กรุณาตรวจสอบ วันที่อนุมัติ' }
  ]

  if (!['VSA', 'JCB', 'MAS'].includes(data.creditCard_Type_dcr)) {
    checkKey.push({ key: 'creditCard_SignDate', error: 'กรุณาตรวจสอบ วันที่อนุมัติ' })
    checkKey.push({ key: 'creditCard_ApprovalDate', error: 'กรุณาตรวจสอบ วันที่อนุมัติ' })
    checkKey.push({ key: 'creditCard_ApprovalCode', error: 'กรุณาตรวจสอบ รหัสอนุมัติ' })
  }

  for (const check of checkKey) {
    const checkData = data[check.key as keyof DocumentDetailModel]
    if (!checkData) {
      errors.push(check)
    } else if (check.key === 'creditCard_ExpDate') {
      const splitExpireFormat = checkData.split('/')
      const expireCard = dayjs(`20${splitExpireFormat[1]}-${splitExpireFormat[0]}-01`).format(
        'YYYY-MM-DD'
      )
      const isNotExpireCard = dayjs().isSameOrBefore(expireCard, 'month')

      if (!isNotExpireCard) {
        errors.push({ ...check, error: 'กรุณาตรวจสอบวันหมดอายุบัตร' })
      }
    } else if (check.key === 'creditCard_Number' && checkData.replace(/ /g, '').length !== 16) {
      errors.push({ ...check, error: 'กรุณาตรวจสอบเลขบัตร' })
    }
  }

  //validateUploadFile(data.paymentMethod.id, data.receipt || [], errors)
  validateUploadFile_CC(data.paymentMethod.id, data.receipt || [], errors, data.creditCard_Type_dcr)

  return errors
}

export const validateFwdCKC = (data: DocumentDetailModel) => {
  const errors: { key: string; error: string }[] = []
  const checkData = [
    { key: 'paymentAmount', error: 'กรุณาตรวจสอบจำนวนเงิน' },
    { key: 'cheque_Number', error: 'กรุณาตรวจสอบเลขที่' },
    { key: 'cheque_Date', error: 'กรุณาตรวจสอบวันที่สั่งจ่าย' }
  ]

  for (const check of checkData) {
    if (!data[check.key as keyof DocumentDetailModel]) {
      errors.push(check)
    }
  }

  validateUploadFile(data.paymentMethod.id, data.receipt || [], errors)

  return errors
}

export const validateQRCode = (data: DocumentDetailModel) => {
  const errors: { key: string; error: string }[] = []
  const checkData = [
    { key: 'paymentAmount', error: 'กรุณาตรวจสอบจำนวนเงิน' },
    { key: 'bankCode', error: 'กรุณาตรวจสอบจำนวนเงิน' },
    { key: 'accountNo', error: 'กรุณาตรวจสอบเลขที่' },
    { key: 'payInDate', error: 'กรุณาตรวจสอบวันที่ฝาก' }
  ]

  for (const check of checkData) {
    if (!data[check.key as keyof DocumentDetailModel]) {
      errors.push(check)
    }
  }

  validateUploadFile(data.paymentMethod.id, data.receipt || [], errors)

  return errors
}

export const validateDocumentDetails = (data: DocumentDetailModel) => {
  switch (data.paymentMethod?.id) {
    case 1: // cash
    case 5: // cash payin
      return validateCash(data)

    case 2: // ckc
    case 6: // ckc payin
      return validateCKC(data)

    case 3: // credit card
      return validateCC(data)

    case 7:
      return validateFwdCKC(data)

    case 8:
      return validateQRCode(data)
  }
}

export const handleCheckPaymentDetail = (
  paymentDetail: DocumentDetailModel[],
  checkboxName: string
) => {
  let other_pay_isCheck = false

  const updateCheckState = paymentDetail.map(item => {
    if (item.paymentMethod.name === checkboxName) {
      if (item.paymentMethod.id == 4) other_pay_isCheck = !item.isCheck
      return { ...item, isCheck: !item.isCheck }
    } else if (item.paymentMethod.id > 4) {
      if (!other_pay_isCheck) {
        other_pay_isCheck = paymentDetail.filter(i => {
          return i.paymentMethod.id == 4
        })[0].isCheck as boolean
      }

      if (!other_pay_isCheck) return { ...item, isCheck: false }
      else return { ...item, isCheck: item.isCheck }
    } else {
      return item
    }
  })
  return updateCheckState
}
